import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/lib/logger';

/**
 * Purges a manuscript's backups and version history from Supabase cloud storage.
 */
export async function purgeCloudManuscript(userId: string, manuscriptId: string): Promise<void> {
  try {
    const [backupRes, versionRes] = await Promise.all([
      supabase
        .from('manuscript_backups')
        .delete()
        .eq('manuscript_id', manuscriptId)
        .eq('user_id', userId),
      supabase
        .from('manuscript_versions')
        .delete()
        .eq('manuscript_id', manuscriptId)
        .eq('user_id', userId),
    ]);

    if (backupRes.error) {
      console.error(`[PurgeCloud] Error deleting manuscript backup ${manuscriptId}:`, backupRes.error);
    }
    if (versionRes.error) {
      console.error(`[PurgeCloud] Error deleting manuscript versions for ${manuscriptId}:`, versionRes.error);
    }

    logger.log(`[PurgeCloud] Purged cloud data for manuscript ${manuscriptId}`);
  } catch (err) {
    console.error(`[PurgeCloud] Exception purging manuscript ${manuscriptId}:`, err);
  }
}
